import { isWithinTimeRange } from '@nf/utils-common/date-time';
import { useLicSettings } from '@/domains/config/hooks/use-lic-settings';
import { WC_PROMOTION_ENDED_TIME } from '../constants';

/**
 * WC promotion UI 顯示條件：lic 開啟 lucky spin(or weekly lottery or after party) 且尚未超過活動結束時間。
 */
export const useWcPromotionVisible = () => {
	const { enableWcPromotionLuckySpin } = useLicSettings();
	const isWcPromotionVisible = enableWcPromotionLuckySpin && isWithinTimeRange({ to: WC_PROMOTION_ENDED_TIME })

	return isWcPromotionVisible;
};
